import React from 'react';
import { MessageCircle, Sparkles } from 'lucide-react';

export const DestinationCard = ({ destination }) => {
  const handleClick = () => {
    if (destination.whatsappLink) {
      window.open(destination.whatsappLink, '_blank');
    } else {
      alert(`El grupo de WhatsApp de ${destination.name} estará disponible próximamente. ¡Vuelve pronto!`);
    }
  };

  return (
    <div 
      onClick={handleClick}
      className="group relative overflow-hidden rounded-2xl cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-2xl"
    >
      <div className="aspect-[4/3] relative">
        <img 
          src={destination.image} 
          alt={destination.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-300"></div>
        
        {destination.popular && (
          <div className="absolute top-3 right-3 flex items-center gap-1 bg-yellow-400 text-yellow-900 px-3 py-1 rounded-full text-xs font-bold">
            <Sparkles className="w-3 h-3" />
            <span>Popular</span>
          </div>
        )}
        
        {destination.special && (
          <div className="absolute top-3 right-3 flex items-center gap-1 bg-purple-500 text-white px-3 py-1 rounded-full text-xs font-bold">
            <Sparkles className="w-3 h-3" />
            <span>Especial</span>
          </div>
        )}
        
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <h3 className="text-white text-xl sm:text-2xl font-bold mb-2">
            {destination.name}
          </h3>
          
          <div className="flex items-center gap-2 text-white/90">
            <MessageCircle className="w-4 h-4" />
            <span className="text-sm font-medium">Unirse al grupo</span>
          </div>
          
          <div className="mt-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div className="inline-flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
              Abrir WhatsApp
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
